export const WORKBOOK_DIVIDE = [
  {
    label: '기본',
    id: 0,
    checked: 'check_default',
    uncheck: 'uncheck_default',
  },
  { label: '2분할', id: 2, checked: 'check_2', uncheck: 'uncheck_2' },
  { label: '4분할', id: 4, checked: 'check_4', uncheck: 'uncheck_4' },
] as const

export const WORKBOOK_CONCEPT_DIVIDE = [
  {
    label: '단원 앞',
    id: 'CHAPTER',
    checked: 'check_default',
    uncheck: 'uncheck_default',
  },
  { label: '교재 맨 앞', id: 'FRONT', checked: 'check_default', uncheck: 'uncheck_default' },
] as const

export const WORKBOOK_DOWNLOAD_PDF_TYPE: Record<
  Exclude<
    req.WorkbookDownloadParamsV2['workbookPdfTypes'][number],
    'QUICK_ANSWER' | 'ANSWER_SOLUTION'
  >,
  string
> = {
  ELEMENT: '문제지',
  ORIGINAL: '문제+정답해설',
} as const
